module.exports = __webpack_public_path__ + "141876d1bacd52a5eafd465809402e37.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/vectorTOBACCO.jpg
// module id = 1129
// module chunks = 1